import { LooseObject } from '../loose-object';
import { data_get, data_is_true } from '../../shared/utils/common';

export class PurchaseOrderLine {
  item_id?: string;
  item_code?: string;
  item_name?: string;
  account_code?: string;
  account_code_id?: string;
  account_code_name?: string;
  tax_code?: string;
  tax_code_id?: string;
  tax_code_name?: string;
  tax_rate?: number;
  department_id?: string;
  department_name?: string;
  description?: string;
  quantity?: number;
  unit_cost?: number;
  item_accounting_id?: string;
  job_id?: string;
  job_number?: string;
  current_stock_level?: number;
  supplier_pricing?: Array<LooseObject>;
  related_products?: Array<LooseObject>;
  supplier_pricing_note?: string;
  show_related_job_field?: boolean;
  labor?: boolean;
  job_task_id?: string;
  job_task_text?: string;

  /// jobs props
  enable_cost_centers?: boolean;

  constructor(data: LooseObject){
    this.item_id = data_get(data, 'item_id');
    this.item_code = data_get(data, 'item_code');
    this.item_name = data_get(data, 'item_name');
    this.account_code = data_get(data, 'account_code');
    this.account_code_id = data_get(data, 'account_code_id');
    this.account_code_name = data_get(data, 'account_code_name');
    this.tax_code = data_get(data, 'tax_code');
    this.tax_code_id = data_get(data, 'tax_code_id');
    this.tax_code_name = data_get(data, 'tax_code_name');
    this.tax_rate = data_get(data, 'tax_rate');
    this.department_id = data_get(data, 'department_id');
    this.department_name = data_get(data, 'department_name');
    this.description = data_get(data, 'description');
    this.quantity = data_get(data, 'quantity');
    this.unit_cost = data_get(data, 'unit_cost');
    this.item_accounting_id = data_get(data, 'item_accounting_id');
    this.job_id = data_get(data, 'job_id');
    this.job_number = data_get(data, 'job_number');
    this.current_stock_level = data_get(data, 'current_stock_level');
    this.supplier_pricing = data_get(data, 'supplier_info');
    this.related_products = data_get(data, 'related_products');
    this.supplier_pricing_note = data_get(data, 'supplier_pricing_note');
    this.show_related_job_field = data_get(data, 'show_related_job_field');
    this.labor = data_get(data, 'labor');

    this.job_task_id = data_get(data, 'job_task_id');
    this.job_task_text = data_get(data, 'job_task_text');
    this.enable_cost_centers = data_is_true(data_get(data, 'enable_cost_centers'));
  }
}